import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const addCustomer = data =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: '/customer',
    data,
  });
